import React from 'react'
import { useDispatch } from 'react-redux'

import { fetchAllChannels } from 'data/channels/actions'

export default function useChannelsRefresher() {
  const dispatch = useDispatch()
  React.useEffect(
    function refreshChannels() {
      dispatch(fetchAllChannels())
    },
    [dispatch] // should be equivalent to componentDidMount
  )
}
